// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3phRN","colBig":"styles_colBig__xh7HT","colSmall":"styles_colSmall__1pbgx"};